import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONSTANSTS } from '@core/constants';
import { ConsumptionByFacilityModel, ConsumptionDetailManuel, EnergyTypeColumnPreference, EnergyTypeListModel, FacilityResourceConsumptionDataInfoModel, FacilityResourceTree } from '@shared/models';
import { Observable } from 'rxjs';

@Injectable()
export class ConsumptionSummaryService {

  constructor(private http: HttpClient) { }

  /**
   * Detaylı tüketim özeti bilgisi döndürür
   * @param {object} param
   */
  getConsumptionByFacility(param?: any): Observable<ConsumptionByFacilityModel> {
    return this.http.get<ConsumptionByFacilityModel>(CONSTANSTS.api.consumptionSummary.getConsumptionByFacility, { params: param });
  }

  /**
   * FacilityResource'Id ye göre tüketim özeti verir..
   * @param {object} param
   */
  getConsumptionByFacilityResource(param?: any): Observable<FacilityResourceConsumptionDataInfoModel> {
    // return this.http.get<FacilityResourceConsumptionDataInfoModel>('http://localhost:3001/GetConsumptionByFacilityResourceAll');
    return this.http.get<ConsumptionByFacilityModel>(CONSTANSTS.api.consumptionSummary.getConsumptionByFacilityResource, { params: param });
  }

  /**
   * Tüketim türleri
   */
  getEnergyTypeListByFacility(param?: any): Observable<EnergyTypeListModel[]> {
    // return this.http.get<EnergyTypeListModel[]>('http://localhost:3001/energytypes');
    return this.http.get<EnergyTypeListModel[]>(CONSTANSTS.api.consumptionSummary.getEnergyTypeListByFacility, { params: param });
  }

  /**
   * Tesise ait yük ağacını getirir.
   * @param facilityID
   */
  getFacilityResourcesTree(facID: string): Observable<FacilityResourceTree[]> {
    return this.http.get<FacilityResourceTree[]>(CONSTANSTS.api.consumptionSummary.getFacilityResourcesTree, { params: { facilityID: facID } });
  }

  /**
   * Aylık tüketimleri geçtiğimiz aydan 120 ay geriye getirir.
   * @param facilityID, facilityResourceID
   */
  getConsumptionManuel(param: any): Observable<ConsumptionDetailManuel[]> {
    return this.http.get<ConsumptionDetailManuel[]>(CONSTANSTS.api.consumptionSummary.getConsumptionManuel, { params: param });
  }

  /**
   * Tüketim verilerinin manuel girilebilmesi , enerji tipi kolon tercihleri
   * @param {object} param
   */
  getEnergyTypeColumnPreference(param?: any): Observable<EnergyTypeColumnPreference[]> {
    return this.http.get<EnergyTypeColumnPreference[]>(CONSTANSTS.api.consumptionSummary.getEnergyTypeColumnPreference, { params: param });
  }


  /**
   * Eski verilere dön
   * @param facilityId, facilityResourceId, consumptionManuelLists
   */
  setOriginalConsumptionManuel(param: any): Observable<any> {
    return this.http.post(CONSTANSTS.api.consumptionSummary.setOriginalConsumptionManuel, param);
  }

  /**
   * Excel'e aktarma servisi
   * @param json
   */
  getPowerConsumptionExcel(param: any): Observable<any> {
    return this.http.post(CONSTANSTS.api.consumptionSummary.getPowerConsumptionExcel, param);
  }

  /**
   * Kaydet işlemi
   * @param facilityId, facilityResourceId, consumptionManuelLists
   */
  setConsumptionManuel(param: any): Observable<any> {
    return this.http.post(CONSTANSTS.api.consumptionSummary.setConsumptionManuel, param);
  }

}
